(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    /*
    ValoraaBead: the search panel drops down from the bottom edge of the header (Atolea). The edge is
    measured when the dialog opens, so it follows the sticky header and the rows above it.
  */
  (() => {
    const place = () => {
      const dialog = document.querySelector('.search-modal__content--vb');
      const header = document.querySelector('#header-component');
      if (!dialog || !header) return;
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      dialog.style.setProperty('--vb-search-top', `${bottom}px`);
    };

    document.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('.search-action button, [on\\:click*="search-modal"]')) place();
    }, { capture: true });
    window.addEventListener('resize', place);
    document.getElementById('search-modal')?.addEventListener('dialog:open', place);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sorting"] && !Shopify.designMode) return;
  try {
    /* Valoraa: when the sort popover opens, move focus to the checked option so Tab/arrow keys start there
     (Horizon's own focus call runs before the panel is focusable and is lost). */
  (() => {
    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) return;
        if (!details.id.startsWith('Sorting-') || !details.closest('.vb-results')) return;
        const listbox = details.querySelector('[role="listbox"]');
        if (!listbox) return;
        const focusSelected = () => {
          if (!details.open || listbox.contains(document.activeElement)) return;
          const option =
            listbox.querySelector('[role="option"][aria-selected="true"]') ||
            listbox.querySelector('[role="option"]');
          if (option instanceof HTMLElement) option.focus({ preventScroll: true });
        };
        requestAnimationFrame(focusSelected);
        setTimeout(focusSelected, 120);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vb-header-drawer-extras"] && !Shopify.designMode) return;
  try {
    /*
    ValoraaBead: Horizon's drawer releases the focus trap on close but doesn't move focus, so after
    Escape (or the close button) focus fell to <body>. Return it to the menu button (WCAG 2.4.3).
  */
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || details.id !== 'Details-menu-drawer-container' || details.open) return;
      const summary = details.querySelector(':scope > summary');
      const active = document.activeElement;
      if (!summary || active === summary) return;
      if (!active || active === document.body || details.contains(active)) summary.focus({ preventScroll: true });
    },
    true
  );

  /*
    ValoraaBead: Horizon closes "the closest details" on Escape. With focus on a closed accordion
    row that is the accordion itself, so Escape did nothing and the menu stayed open. Close the
    whole menu instead (an open accordion still closes first, as before).
  */
  document.addEventListener(
    'keyup',
    (event) => {
      if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
      const drawer = event.target.closest('header-drawer');
      const container = drawer?.querySelector('#Details-menu-drawer-container');
      const details = event.target.closest('details');
      if (!drawer || !container?.open || !details || details === container || details.open) return;
      event.stopPropagation();
      if (typeof drawer.close === 'function') drawer.close();
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vb-header-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vb-header-nav')) {
    const CLOSE_DELAY = 140;

    /**
     * Desktop nav with small dropdown panels. Hover opens (with a short close delay so the pointer
     * can travel into the panel); the caret button toggles; ArrowDown opens and moves into the
     * panel; Arrow keys move between panel links; Escape or focus leaving the item closes it.
     */
    class VbHeaderNav extends HTMLElement {
      /** @type {HTMLElement | null} */
      #openItem = null;
      /** @type {ReturnType<typeof setTimeout> | undefined} */
      #closeTimer;
      #abort = new AbortController();

      connectedCallback() {
        const { signal } = this.#abort;
        for (const item of this.querySelectorAll('.vb-nav__item--parent')) {
          item.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'touch') return;
            clearTimeout(this.#closeTimer);
            this.open(item);
          }, { signal });
          item.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'touch') return;
            this.#scheduleClose(item);
          }, { signal });
          item.addEventListener('focusout', (event) => {
            const next = event.relatedTarget;
            if (!(next instanceof Node) || !item.contains(next)) this.close(item);
          }, { signal });
          item.addEventListener('keydown', (event) => this.#onKeydown(event, item), { signal });
          item.querySelector('[data-vb-nav-toggle]')?.addEventListener('click', () => {
            if (this.#isOpen(item)) this.close(item);
            else this.open(item);
          }, { signal });
        }
      }

      disconnectedCallback() {
        this.#abort.abort();
        clearTimeout(this.#closeTimer);
      }

      /** @param {HTMLElement} item */
      #isOpen(item) {
        return item.querySelector('[data-vb-nav-toggle]')?.getAttribute('aria-expanded') === 'true';
      }

      /** @param {HTMLElement} item */
      open(item) {
        if (this.#openItem && this.#openItem !== item) this.close(this.#openItem);
        const toggle = item.querySelector('[data-vb-nav-toggle]');
        const panel = item.querySelector('[data-vb-nav-panel]');
        if (!toggle || !panel) return;
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        this.#openItem = item;
      }

      /** @param {HTMLElement} item */
      close(item) {
        const toggle = item.querySelector('[data-vb-nav-toggle]');
        const panel = item.querySelector('[data-vb-nav-panel]');
        toggle?.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
        if (this.#openItem === item) this.#openItem = null;
      }

      /** @param {HTMLElement} item */
      #scheduleClose(item) {
        clearTimeout(this.#closeTimer);
        this.#closeTimer = setTimeout(() => this.close(item), CLOSE_DELAY);
      }

      /**
       * @param {KeyboardEvent} event
       * @param {HTMLElement} item
       */
      #onKeydown(event, item) {
        const toggle = item.querySelector('[data-vb-nav-toggle]');
        const links = [...item.querySelectorAll('.vb-nav__sublink')];
        const index = links.indexOf(/** @type {HTMLElement} */ (document.activeElement));

        if (event.key === 'Escape' && this.#isOpen(item)) {
          event.preventDefault();
          this.close(item);
          if (toggle instanceof HTMLElement) toggle.focus();
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (!this.#isOpen(item)) this.open(item);
          const next = links[index + 1] ?? links[0];
          next?.focus();
          return;
        }

        if (event.key === 'ArrowUp' && index > -1) {
          event.preventDefault();
          if (index === 0 && toggle instanceof HTMLElement) toggle.focus();
          else links[index - 1]?.focus();
        }
      }
    }

    customElements.define('vb-header-nav', VbHeaderNav);
  }
  } catch(e) { console.error(e); }
})();

})();
